import { Component, Input } from "@angular/core";
import { ErrorClass, InternalServerError, UnauthorizedError, ValidationError } from "@models";
import { VerificationPinComponent } from "./verification-pin.component";
import { SavingsPlan } from "@models/savings_plan";
import { Helper } from "@helpers/functions";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { SavingsModel } from "@models/savings";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";

@Component({
	selector: "two-fa-verify-savings",
	templateUrl: "./verification-pin.component.html",
	standalone: false
})
export class VerificationPinSavingsComponent extends VerificationPinComponent implements BpModalHasSave {
	// Override
	@Input() public offer = null;

	@Input() public savingsData: SavingsModel;

	public constructor(
		protected apicallService: ApicallService,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {
		super(apicallService, translationService, infoService);
	}

	// Override
	public createPinRequest(type: string = "sms"): void {
		// API call:
		const url = "savings/plans/" + this.savingsData.paymentPlan.getId() + "/confirm?type=" + type;
		this.apicallService.get(url).subscribe(
			() => {
				this.pinSentF.emit(true);
				this.infoService.setSuccess(this.translationService.translate("sms_code_was_sent"));
			},
			(err) => Helper.handleError(err)
		);
	}

	// Override
	public save(): void {
		if (this.verificationPin._code.length !== 4) {
			return;
		}
		if (!this.done) {
			const translation = this.translationService.translate("invalid_sms_code");
			this.infoService.setWarning(translation);
			return;
		}

		// API call:

		const a = new ApicallOption(SavingsPlan, this.verificationPin);
		const url = "savings/plans/" + this.savingsData.paymentPlan.getId() + "/confirm";
		a.ignore401 = true; // Do we need this?

		this.apicallService.post(url, a).subscribe(
			(res) => {
				const plan = res[0];
				this.accept.emit(plan);
			},
			(err) => {
				if (err instanceof ErrorClass) {
					if (err instanceof UnauthorizedError) {
						this.infoService.setError(
							this.translationService.translate("info_text_verify_pin_invalid_pin")
						);
					} else if (err instanceof ValidationError) {
						this.infoService.setError(err);
						this.verificationPin.setValidationErrors(err);
					} else if (err instanceof InternalServerError) {
						this.infoService.setError(err);
						this.accept.emit(null);
					}
				} else {
					console.error("Err: ", err);
				}
			}
		);
	}
}
